import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import NavBar from '../../components/NavBar/NavBar';
import { BASE_URL } from '../../components/AppConfig';
import { handleDynamicRequest } from '../../components/DyanamicRequest';

const ResetPassword = () => {
  const [formState, setFormState] = useState({
    email: '',
    oldPassword: '',
    newPassword: '',
  });
  const [passwordVisibility, setPasswordVisibility] = useState({
    old: false,
    new: false,
  });
  const [alertState, setAlertState] = useState({ success: '', error: '' });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const navigate = useNavigate();

  const handleChange = (field) => (event) => {
    setAlertState({ success: '', error: '' });
    setFormState((prev) => ({
      ...prev,
      [field]: event.target.value,
    }));
  };

  const togglePasswordVisibility = (field) => () => {
    setPasswordVisibility((prev) => ({
      ...prev,
      [field]: !prev[field],
    }));
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    setAlertState({ success: '', error: '' });

    const { email, oldPassword, newPassword } = formState;

    if (!email) {
      setAlertState({
        success: '',
        error: 'Email is required to identify the user.',
      });
      return;
    }

    if (!oldPassword) {
      setAlertState({
        success: '',
        error: 'Current password is required.',
      });
      return;
    }

    if (!newPassword || newPassword.length < 6) {
      setAlertState({
        success: '',
        error: 'New password must be at least 6 characters.',
      });
      return;
    }

    if (oldPassword === newPassword) {
      setAlertState({
        success: '',
        error: 'New password must be different from the current password.',
      });
      return;
    }

    const payload = {
      old_password: oldPassword,
      new_password: newPassword,
      email,
    };

    setIsSubmitting(true);

    const method = 'POST';
    const url = `${BASE_URL}/admin/user/reset-password`;

    const wrongResponse = (error) => {
      const message =
        (error && (error.message || error.error)) ||
        'Failed to reset password.';
      setAlertState({ success: '', error: message });
    };

    const rightResponse = (data) => {
      const message = data?.message || 'Password reset successfully';
      setAlertState({ success: message, error: '' });
      setFormState({
        email: '',
        oldPassword: '',
        newPassword: '',
      });
    };

    try {
      await handleDynamicRequest(method, url, payload, wrongResponse, rightResponse);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <section>
      <NavBar login={{ status: true }} />
      <div className="container-fluid p-0">
        <div className="row">
          <div className="col-12">
            <div className="login-card">
              <form className="theme-form login-form" onSubmit={handleSubmit}>
                <h4>Reset Password</h4>
                <p className="text-muted mb-3">
                  Enter the user's email to reset their password.
                </p>
                <div className="form-group">
                  <label>Email</label>
                  <input
                    className="form-control"
                    type="email"
                    name="email"
                    placeholder="user@example.com"
                    value={formState.email}
                    onChange={handleChange('email')}
                    required
                  />
                </div>
                <div className="form-group">
                  <label>Current Password</label>
                  <div className="input-group">
                    <input
                      className="form-control"
                      type={passwordVisibility.old ? 'text' : 'password'}
                      name="old-password"
                      placeholder="Current password"
                      value={formState.oldPassword}
                      onChange={handleChange('oldPassword')}
                      required
                    />
                    <button
                      type="button"
                      className="btn btn-outline-secondary"
                      onClick={togglePasswordVisibility('old')}
                    >
                      {passwordVisibility.old ? 'Hide' : 'Show'}
                    </button>
                  </div>
                </div>
                <div className="form-group">
                  <label>New Password</label>
                  <div className="input-group">
                    <input
                      className="form-control"
                      type={passwordVisibility.new ? 'text' : 'password'}
                      name="new-password"
                      placeholder="Minimum 6 characters"
                      value={formState.newPassword}
                      onChange={handleChange('newPassword')}
                      required
                    />
                    <button
                      type="button"
                      className="btn btn-outline-secondary"
                      onClick={togglePasswordVisibility('new')}
                    >
                      {passwordVisibility.new ? 'Hide' : 'Show'}
                    </button>
                  </div>
                </div>
                {alertState.error && <div className="alert alert-danger">{alertState.error}</div>}
                {alertState.success && <div className="alert alert-success">{alertState.success}</div>}
                <div className="form-group">
                  <button
                    className="btn btn-secondary btn-block"
                    type="submit"
                    disabled={isSubmitting}
                  >
                    {isSubmitting ? 'Resetting...' : 'Reset Password'}
                  </button>
                </div>
                <div className="form-group text-center">
                  <button
                    type="button"
                    className="btn btn-link p-0"
                    onClick={() => navigate('/login')}
                  >
                    Back to Login
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ResetPassword;

